// src/pages/documents/RulesFI.js
          //this will be painful to update
import React from 'react';

const MembershipPrivacyPolicy = () => {
  return (
    <div className="page rules-page">
      <section className="page-header">
        <div className="container">
          <h1>Privacy policy</h1>
        </div>
      </section>

      <section className="content-section">
        <div className="container">

          <div className="rule-card">
            <h2>Membership privacy policy </h2>
            <p>Report on the processing of personal data pursuant to the EU’s 
              General Data Protection Regulation (679/2016). This privacy statement describes the 
              collection and administration of personal information of members, who belong to the member 
              registry of Integralis ry. Date of formulation 15.09.2022. Latest change 4.1.2026. </p>
            <p>
              <h3> 1. Controller </h3>
<p>Integralis ry (3115891-9)</p>

<p>PL 68 </p>
<p>00014 University of Helsinki  </p>
<p>Finland</p> 
<p>integralis@helsinki.fi </p>
              <h3>2. Contact person responsible for the registry </h3>
<p>President of Integralis ry, Aleksi Kiema </p>
<p>aleksi.kiema(at)helsinki(dot)fi </p>

              <h3>3. Name of the registry </h3>
Official membership registry of Integralis ry 

<h3>4. Communication regarding privacy matters </h3>
We request that data subjects contact the person listed hereinabove 
for all questions related to the processing of personal data and situations related to the exercising of your rights. 

<h3>5. Basis and purpose of processing personal data </h3>
The legal basis for the processing of personal data is the contractual relationship between the data 
subject and controller. The purpose of processing personal data is the maintenance of a member registry, checking of voting right during statutory meetings, 
 and the maintenance of organization's members’ contact information, required by the (503/1989) 11§ of Associations Act. 

<h3>6. Regular data sources </h3>
Information from people who do not belong to the organization is not stored. Only members’ 
personal information will be stored in the registry. The personal data to be processed is 
regularly received from the members themselves when they decide to become members. 
The data is collected with a form, which the member fills in. 

<h3>7. Personal data being processed </h3>
<p>The controller only collects personal data concerning the data subjects that is essential 
  and relevant for the purposes explained in this privacy statement. 
  The following data concerning the data subjects is processed: </p>
<ul>
  <li>First and last name </li>
  <li>Email address </li>
  <li>Information concerning the official membership (part of faculty of science and/or Bachelor’s Programme in Science or not) </li>
  <li>Municipality and home country </li>
</ul>

<h3>8. Disclosure of personal data </h3>
Personal data is generally not disclosed to third parties. 
The registry administrator may transfer personal data to third parties 
(i.e. data storage service providers), following the practices of common operating. 
The registry administrator ensures, that the transfer and processing of personal data is performed securely and 
that it follows appropriate information security agreements 
(see e.g. Kide.app data processing agreement <a href='https://kide.app/en/help/merchant-terms'>Kide app merchant terms</a> section 9.) 
Data subjects’ personal 
data can be transferred to partners in cooperation, 
data processing- and communication service providers, and accounting- and audit service providers. 

<h3>9. Transfers of personal data to third countries </h3>
As a rule, personal data will not be transferred outside of the EU and the European Economic Area. However, 
if this is done for a special reason, the transfer will be implemented in accordance with the European Commission’s 
decision on the adequacy of privacy protection. 

<h3>10. Retention period for personal data </h3>
The controller will process the personal data for the duration of the membership 
payment period, which is from 1st of August till 31st of July during the academic year.
 At the end of this period, the controller will delete or anonymize the data within 180 days in 
 accordance with the deletion processes it follows. The controller may have an obligation to process some 
personal data belonging to the filing system for longer than 
stated above in order to comply with the legislation or authority requirements. 

<h3>11. Rights of the data subject </h3>
<h4>Right to request access to personal data </h4>
The data subject has the right to receive confirmation regarding 
whether personal data concerning them is being processed and, if it is, the right to receive a copy of their personal data. 

<h4>Right to rectification  </h4>
The data subject has the right to request that inaccurate and erroneous personal data concerning them be rectified. 
The data subject also has the right to supplement incomplete personal data by submitting the required additional information. 

<h4>Right to erasure  </h4>
The data subject has the right to request erasure of personal data concerning them if 
<ol type="a  ">
  <li>the personal data is no longer required for the purposes for which they were collected; or</li>
  <li>the personal data has been unlawfully processed</li>
</ol>

<h4>Right to restriction of processing </h4>
The data subject has the right to restrict the processing of personal data concerning them if 
<ol type="a">
  <li>the data subject contests the accuracy of their personal data; </li>
  <li> the processing is unlawful and the data subject opposes the erasure of the personal data and requests the restriction of its use instead; or</li>
  <li> the controller no longer needs the personal data for the purposes of the processing, 
    but it is required by the data subject for the establishment, exercise or defence of legal claims. </li>
  </ol>

<h4>Right to data portability </h4>
The data subject has the right to receive the personal data concerning them, which they have provided to a controller, 
in a structured, commonly used and machine-readable format and have the right to transmit this data to another controller. 
            
<h4>Right to lodge a complaint with a supervisory authority </h4>
The office of the Data Protection Ombudsman, operating under the Ministry of Justice,
 is the national supervisory authority for personal data matters. You have the right to bring your 
case to the supervisory authority if you consider that the processing of personal data concerning you is in violation of applicable law 
            </p>
                          
          </div>

        </div>
      </section>
    </div>
  );
};

export default MembershipPrivacyPolicy;

